module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.07b76bcd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/PlayfairDisplay-Bold.ttf
// module id = 229
// module chunks = 0